import { Link } from "react-router-dom";

function OrderStatusPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f7f8fa",
        padding: "40px 30px",
        fontFamily: "Arial, sans-serif",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "16px",
          padding: "30px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
          maxWidth: "680px",
          width: "100%",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            marginTop: 0,
            marginBottom: "14px",
            color: "#111827",
          }}
        >
          Order Tracking Coming Soon
        </h1>

        <p
          style={{
            marginTop: 0,
            marginBottom: "22px",
            color: "#4b5563",
            lineHeight: "1.6",
          }}
        >
          We are preparing our order tracking system. Please check back soon.
        </p>

        <Link
          to="/"
          style={{
            display: "inline-block",
            textDecoration: "none",
            background: "#111827",
            color: "white",
            padding: "12px 18px",
            borderRadius: "10px",
            fontWeight: "bold",
          }}
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}

export default OrderStatusPage;
